module.exports = __webpack_public_path__ + "static/media/YF58_4.46add53c.jpg";